import { IFieldTypes, LABEL_SUFFIX } from "../../../../constants/form-and-fields"

export enum FIELD_DATA_KEY {
    TAGS = "tagIds",
    REDEMPTION_TYPE = "redemptionType",
    REDEMPTION_LIMIT = "redemptionLimit",
    IS_MULTI_ITEMS = "isMultiItems",
    PRICE = "price",
    VOUCHER = "voucherPrice",
    DISCOUNT_INPUT_TYPE = "discountInputType",
    DISCOUNT_PERCENTAGE = "discountPercentage",
    DISCOUNT_PRICE = "discountPrice",
    RANGE_DATE_PICKER = 'rangeDatePicker',
    TITLE = "title",
    DESCRIPTION = "description",
    BRANCHES = "branches",
    PROFILE_PICTURE = "profilePicture",
    BRANCH_NAME = "name",
    BUSINESS_CATEGORY = "categoryId",
    BUSINESS_COVER_PHOTO = "coverPhoto",
    CR_NUMBER = "crNumber",
    UPLOAD_CR_ATTACHMENT = "crUri",
    ESTABLISHMENT_CARD_CODE = "establishmentCardCode",
    TRADE_LICENSE_NUMBER = "tradeLicenseNumber",
    TAX_CARD_NUMBER = "taxCardNumber",
    ESTABLISHMENT_CARD_URI = "establishmentCardUri",
    TRADE_LICENSE_URI = "tradeLicenseUri",
    TAX_CARD_URI = "taxCardUri",
    APPROVED_MENU_URI = "approvedMenuUri",
    CONTACT_MOBILE = "contactMobile",
    CONTACT_WHATSAPP = "contactWhatsapp",
    AGENCY_NAME = "agencyName",
    AGENCY_EMAIL = "agencyEmail",
    USER_EMAIL = "userEmail",
    WEBSITE_URL = "website",
    OFFER_DURATION = "offerDuration",
    IS_TRANCHES = "isTranches",
    TRANCHES_VALIDITY = "trancheValidity",
    ENABLE_SPECIFIC_DAYS = "enableSpecificDays",
    DAY_SELECTION = "validDays",
    TERMS_AND_CONDITIONS = "termsAndConditions",
    BRANCH_LOCATION_URL = "branchLocationUri",
    ESTIMATED_SAVINGS = "estimatedSavings",
    ESTIMATED_SAVINGS_NOTE = "estimatedSavingsNote",
    TITLE_AR = "titleAr",
    DESCRIPTION_AR = "descriptionAr",
    TERMS_AND_CONDITIONS_AR = "termsAndConditionsAr",
    AGENCY_NAME_AR = "agencyNameAr",
    BUSINESS_DESCRIPTION_AR = "aboutAgencyAr",
}

export enum FIELD_NAMES {
    TAGS = "tagIds",
    REDEMPTION_TYPE = "redemptionType",
    REDEMPTION_LIMIT = "redemptionLimit",
    IS_MULTI_ITEMS = "isMultiItems",
    PRICE = "price",
    VOUCHER = "voucherPrice",
    DISCOUNT_INPUT_TYPE = "discountInputType",
    DISCOUNT_PERCENTAGE = "discountPercentage",
    DISCOUNT_PRICE = "discountPrice",
    RANGE_DATE_PICKER = 'rangeDatePicker',
    TITLE = "title",
    DESCRIPTION = "description",
    BRANCHES = "branches",
    START_DATE = "startDate",
    END_DATE = "endDate",
    PROFILE_PICTURE = "imageUri",
    AGENCY_LOGO = "agencyLogoUri",
    BUSINESS_CATEGORY = "categoryId",
    BUSINESS_COVER_PHOTO = "coverPhoto",
    BUSINESS_DESCRIPTION = "aboutAgency",
    START_DAY = "startDay",
    END_DAY = "endDay",
    START_HOUR = "startHour",
    END_HOUR = "endHour",
    WORKING_HOURS = "workingHours",
    WEBSITE = "website",
    CR_NUMBER = "crNumber",
    UPLOAD_CR_ATTACHMENT = "crUri",
    ESTABLISHMENT_CARD_CODE = "establishmentCardCode",
    TRADE_LICENSE_NUMBER = "tradeLicenseNumber",
    TAX_CARD_NUMBER = "taxCardNumber",
    ESTABLISHMENT_CARD_URI = "establishmentCardUri",
    TRADE_LICENSE_URI = "tradeLicenseUri",
    TAX_CARD_URI = "taxCardUri",
    APPROVED_MENU_URI = "approvedMenuUri",
    CONTACT_MOBILE = "contactMobile",
    CONTACT_WHATSAPP = "contactWhatsapp",
    AGENCY_NAME = "agencyName",
    AGENCY_EMAIL = "agencyEmail",
    USER_EMAIL = "userEmail",
    OFFER_DURATION = "offerDuration",
    IS_TRANCHES = "isTranches",
    TRANCHES_VALIDITY = "trancheValidity",
    ENABLE_SPECIFIC_DAYS = "enableSpecificDays",
    DAY_SELECTION = "validDays",
    TERMS_AND_CONDITIONS = "termsAndConditions",
    BRANCH_LOCATION_URL = "branchLocationUri",
    ESTIMATED_SAVINGS = "estimatedSavings",
    ESTIMATED_SAVINGS_NOTE = "estimatedSavingsNote",
    TITLE_AR = "titleAr",
    DESCRIPTION_AR = "descriptionAr",
    TERMS_AND_CONDITIONS_AR = "termsAndConditionsAr",
    AGENCY_NAME_AR = "agencyNameAr",
    BUSINESS_DESCRIPTION_AR = "aboutAgencyAr",
}

export const redemptionTypeField: IFormField = {
    type: IFieldTypes.SELECT,
    dataKey: FIELD_DATA_KEY.REDEMPTION_TYPE,
    props: {
      name: FIELD_NAMES.REDEMPTION_TYPE,
      rules: { required: 'Redemption Type is required.' },
      inputProps: {
        label: 'Redemption',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
        fullWidth: false,
        width:'65%',
        marginRight:'14px'
      },
      selectProps: {
        emptyValueLabel: 'Choose',
      },
      optionsProps: {
        optionArray: [],
      },
    },
}

export const redemptionLimitField: IFormField = {
    type: IFieldTypes.INPUT,
    dataKey: FIELD_DATA_KEY.REDEMPTION_LIMIT,
    props: {
      name: FIELD_NAMES.REDEMPTION_LIMIT,
      inputProps: {
        fullWidth:false,
        width:'31%',
        label: 'Limit Per User',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
      },
      inputTextFieldProps: {
        type: 'Number',
        shouldParse: true,
        charMaxLength: 10,
      },
    },
}

export const isMultiItemsField: IFormField = {
    type: IFieldTypes.CHECKBOX,
    dataKey: FIELD_DATA_KEY.IS_MULTI_ITEMS,
    props: {
        name: FIELD_NAMES.IS_MULTI_ITEMS,
        inputProps: {
        label: 'This Offer is for Multiple Items',
        fullWidth: true,
        },
    },
}

export const PriceField: IFormField = {
    type: IFieldTypes.INPUT,
    dataKey: FIELD_DATA_KEY.PRICE,
    props: {
      name: FIELD_NAMES.PRICE,
      rules: {
        required: 'Price is required.',
        pattern: {
          value: /^\d*\.?\d+$/,
          message: 'Price must be a valid number.',
        },
        validate: {
          positive: (value: string) =>
            parseFloat(value) > 0 || 'Price must be greater than 0.',
        },
      },
  
      inputProps: {
        fullWidth: true,
        label: 'Original Price',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
      },
      inputTextFieldProps: {
        type: 'text',
        shouldParse: true,
        adornment: 'qar',
        charMaxLength: 10,
      },
    },
}

export const VoucherField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.VOUCHER,
  props: {
    name: FIELD_NAMES.VOUCHER,
    rules: {
      required: 'Voucher value is required.',
      pattern: {
        value: /^\d*\.?\d+$/,
        message: 'Voucher value must be a valid number.',
      },
      validate: {
        positive: (value: string) =>
          parseFloat(value) > 0 || 'Voucher value must be greater than 0.',
      },
    },

    inputProps: {
      fullWidth: true,
      label: 'Voucher value',
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
    inputTextFieldProps: {
      type: 'text',
      shouldParse: true,
      adornment: 'qar',
      charMaxLength: 10,
    },
  },
}

export const DiscountPercentField: IFormField = {
    type: IFieldTypes.INPUT,
    dataKey: FIELD_DATA_KEY.DISCOUNT_PERCENTAGE,
    props: {
      name: FIELD_NAMES.DISCOUNT_PERCENTAGE,
      rules: {
        required: 'Discount Percentage is required.',
        pattern: {
          value: /^\d*\.?\d+$/,
          message: 'Discount Percentage must be a valid number.',
        },
        validate: {
          positive: (value: string) =>
            parseFloat(value) > 0 || 'Discount Percentage must be greater than 0.',
        },
      },

      inputProps: {
        fullWidth: true,
        label: 'Discount Percentage',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
      },
      inputTextFieldProps: {
        type: 'text',
        shouldParse: true,
        adornment: '%',
        charMaxLength: 3,
      },
    },
}

export const DiscountInputTypeField: IFormField = {
    type: IFieldTypes.SELECT,
    dataKey: FIELD_DATA_KEY.DISCOUNT_INPUT_TYPE,
    props: {
      name: FIELD_NAMES.DISCOUNT_INPUT_TYPE,
      rules: { required: 'Discount Type is required.' },
      inputProps: {
        label: 'Discount Type',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
        fullWidth: true,
      },
      selectProps: {
        emptyValueLabel: 'Choose',
      },
      optionsProps: {
        optionArray: [],
      },
    },
}

export const DiscountPriceField: IFormField = {
    type: IFieldTypes.INPUT,
    dataKey: FIELD_DATA_KEY.DISCOUNT_PRICE,
    props: {
      name: FIELD_NAMES.DISCOUNT_PRICE,
      rules: {
        required: 'Discounted Price is required.',
        pattern: {
          value: /^\d*\.?\d+$/,
          message: 'Discounted Price must be a valid number.',
        },
        validate: {
          positive: (value: string) =>
            parseFloat(value) > 0 || 'Discounted Price must be greater than 0.',
        },
      },
      inputProps: {
        fullWidth: true,
        label: 'Discounted Price',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
      },
      inputTextFieldProps: {
        type: 'text',
        shouldParse: true,
        adornment: 'qar',
        charMaxLength: 10,
      },
    },
}

export const TitleField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.TITLE,
  props: {
    name: FIELD_NAMES.TITLE,
    rules: {
      required: 'Title is required',
    },
    inputProps: {
      fullWidth: true,
      label: 'Title',
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
    inputTextFieldProps: {
      charMaxLength: 80,
      showLimitValue: true,
    },
  },
}

export const DescriptionField: IFormField = {
  type: IFieldTypes.EDITOR,
  dataKey: FIELD_DATA_KEY.DESCRIPTION,
  props: {
    name: FIELD_NAMES.DESCRIPTION,
    rules: { required: 'Description is required' },
    inputProps: {
      fullWidth: true,
      label: 'Description',
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
  },
}

export const LocationsField: IFormField = {
  type: IFieldTypes.SELECT,
  dataKey: FIELD_DATA_KEY.BRANCHES,

  props: {
    name: FIELD_NAMES.BRANCHES,

    rules: { required: 'Branches are required.' },
    inputProps: {
      label: 'Branches',
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
      fullWidth: true,
    },
    selectProps: {
      emptyValueLabel: 'Choose',
      multiple:true
    },
    optionsProps: {
      optionArray: [],
    },
  },
}

export const RangeDatePicker: IFormField = {
  type: IFieldTypes.RANGE_DATE_PICKER,
  dataKey: FIELD_DATA_KEY.RANGE_DATE_PICKER,
  props: {
    name: FIELD_NAMES.RANGE_DATE_PICKER,
  }
}

export const ProfileProfilePicture: IFormField = {
  type: IFieldTypes.FILE,
  dataKey: FIELD_DATA_KEY.PROFILE_PICTURE,
  props: {
    name: FIELD_NAMES.PROFILE_PICTURE,
    rules: {
      validate: (imageUri: string) => {
        if (!imageUri?.trim()) {
          return "Image is required";
        }
        return true;
      },
    },
    inputProps: {
      label: "Upload image",
    },
  },
};

export const BusinessCategoryField: IFormField = {
  type: IFieldTypes.SELECT,
  dataKey: FIELD_DATA_KEY.BUSINESS_CATEGORY,
  props: {
    name: FIELD_NAMES.BUSINESS_CATEGORY,
    inputProps: {
      label: "Business Category",
    },
  },
};

export const BusinessCoverPhotoField: IFormField = {
  ...ProfileProfilePicture,
  dataKey: FIELD_DATA_KEY.BUSINESS_COVER_PHOTO,
  props: {
    ...ProfileProfilePicture.props,
    name: FIELD_NAMES.BUSINESS_COVER_PHOTO,
  },
};

export const ProfileNumberField: IFormField = {
  type: IFieldTypes.NUMBER,
  dataKey: FIELD_DATA_KEY.CR_NUMBER,
  props: {
    name: FIELD_NAMES.CR_NUMBER,
    inputProps: {
      label: "",
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
  },
};

export const UploadAttachmentFile: IFormField = {
  type: IFieldTypes.FILE,
  dataKey: FIELD_DATA_KEY.UPLOAD_CR_ATTACHMENT,
  props: {
    name: FIELD_NAMES.UPLOAD_CR_ATTACHMENT,
    inputProps: {
      label: "",
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
  },
};

export const PhoneNumberField: IFormField = {
  type: IFieldTypes.PHONE_NUMBER,
  dataKey: FIELD_DATA_KEY.CONTACT_MOBILE,
  props: {
    name: FIELD_NAMES.CONTACT_MOBILE,
    rules: {
      required: "Phone Number is required",
      pattern: {
        value: /^\+974/,
        message: "Invalid Qatar number",
      },
      validate: {
        validLength: (value: string) => {
          const digitsOnly = value.trim().replace(/\s+/g, "").slice(4); // Remove spaces and "+974"
          return (
            (digitsOnly.length >= 3 && digitsOnly.length <= 8) ||
            "Invalid Qatar number"
          );
        },
      },
    },
    inputProps: {
      label: "Phone Number",
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
  },
};

export const WhatsappNumberField: IFormField = {
  type: IFieldTypes.PHONE_NUMBER,
  dataKey: FIELD_DATA_KEY.CONTACT_WHATSAPP,
  props: {
    name: FIELD_NAMES.CONTACT_WHATSAPP,
    rules: {
      required: "Whatsapp Number is required",
      pattern: {
        value: /^\+974/,
        message: "Invalid Qatar number",
      },
      validate: {
        validLength: (value: string) => {
          const digitsOnly = value.trim().replace(/\s+/g, "").slice(4); // Remove spaces and "+974"
          return (
            (digitsOnly.length >= 3 && digitsOnly.length <= 8) ||
            "Invalid Qatar number"
          );
        },
      },
    },
    inputProps: {
      label: "Whatsapp Number",
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
  },
};

export const AgencyNameField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.AGENCY_NAME,
  props: {
    name: FIELD_NAMES.AGENCY_NAME,
    inputProps: {
      label: "Agency Name",
    },
    inputTextFieldProps: {
      charMaxLength: 50,
    },
  },
};

export const AgencyEmailField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.AGENCY_EMAIL,
  props: {
    name: FIELD_NAMES.AGENCY_EMAIL,
    rules: {
      required: "Email is required",
      // Ensure the email is trimmed before validation
      validate: {
        // Check for leading/trailing spaces and validate email format
        validEmail: (value: string) => {
          if (value) {
            const trimmedValue = value?.trim(); // Trim spaces

            // Validate using regex after trimming
            const isValidEmail =
              /^(?!.*\s)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                trimmedValue
              );

            return isValidEmail || "Invalid Email";
          }
        },
        maxLength: (value: string) =>
          !value || value.trim().length <= 50 || "Invalid Email",
      },
    },
    inputProps: {
      label: "Business email",
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
  },
};

export const UserEmailField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.USER_EMAIL,
  props: {
    name: FIELD_NAMES.USER_EMAIL,
    rules: {
      required: "User email is required",
      // Ensure the email is trimmed before validation
      validate: {
        // Check for leading/trailing spaces and validate email format
        validEmail: (value: string) => {
          if (value) {
            const trimmedValue = value?.trim(); // Trim spaces

            // Validate using regex after trimming
            const isValidEmail =
              /^(?!.*\s)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                trimmedValue
              );

            return isValidEmail || "Invalid Email";
          }
        },
        maxLength: (value: string) =>
          !value || value.trim().length <= 50 || "Invalid Email",
      },
    },
    inputProps: {
      label: "User email",
      labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
    },
  },
};

export const WebsiteUrlField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.WEBSITE_URL,
  props: {
    name: FIELD_NAMES.WEBSITE,
    inputProps: {
      label: "Website URL",
    },
  },
};

export const offerDurationField: IFormField = {
    type: IFieldTypes.SELECT,
    dataKey: FIELD_DATA_KEY.OFFER_DURATION,
    props: {
      name: FIELD_NAMES.OFFER_DURATION,
      rules: { required: 'Offer Duration is required.' },
      inputProps: {
        label: 'Offer Duration',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
        fullWidth: true,
        marginRight:'14px'
      },
      selectProps: {
        emptyValueLabel: 'Choose',
      },
      optionsProps: {
        optionArray: [],
      },
    },
}

export const isTranchesField: IFormField = {
    type: IFieldTypes.CHECKBOX,
    dataKey: FIELD_DATA_KEY.IS_TRANCHES,
    props: {
        name: FIELD_NAMES.IS_TRANCHES,
        inputProps: {
        label: 'Is this offer valid for two tranches?',
        fullWidth: true,
        },
    },
}

export const tranchesField: IFormField = {
    type: IFieldTypes.SELECT,
    dataKey: FIELD_DATA_KEY.TRANCHES_VALIDITY,
    props: {
      name: FIELD_NAMES.TRANCHES_VALIDITY,
      rules: { required: 'Tranches Validity is required.' },
      inputProps: {
        label: 'Tranches Validity',
        labelSuffix: LABEL_SUFFIX.REQUIRED_FIELD,
        fullWidth: true,
        marginRight:'14px'
      },
      selectProps: {
        emptyValueLabel: 'Choose',
      },
      optionsProps: {
        optionArray: [],
      },
    },
}

export const daySelectionField: IFormField = {
  type: IFieldTypes.DAY_SELECTION,
  dataKey: FIELD_DATA_KEY.DAY_SELECTION,
  props: {
    name: FIELD_NAMES.DAY_SELECTION,
  },
}

export const termsAndConditionsField: IFormField = {
  type: IFieldTypes.OFFER_TERMS_AND_CONDITIONS,
  dataKey: FIELD_DATA_KEY.TERMS_AND_CONDITIONS,
  props: {
    name: FIELD_NAMES.TERMS_AND_CONDITIONS,
  },
}

export const estimatedSavingsField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.ESTIMATED_SAVINGS,
  props: {
    name: FIELD_NAMES.ESTIMATED_SAVINGS,
    inputProps: {
      fullWidth: true,
      label: 'Estimated Savings',
    },
    inputTextFieldProps: {
      type: 'text',
      shouldParse: true,
      adornment: 'qar',
      charMaxLength: 10,
    },
  },
}

export const estimatedSavingsNoteField: IFormField = {
  type: IFieldTypes.INPUT,
  dataKey: FIELD_DATA_KEY.ESTIMATED_SAVINGS_NOTE,
  props: {
    name: FIELD_NAMES.ESTIMATED_SAVINGS_NOTE,
    inputProps: {
      fullWidth: true,
      label: 'Estimated Savings Note',
      rows: 5,
    },
    inputTextFieldProps: {
      charMaxLength: 200,
      showLimitValue: true,
      multiline: true,
    },
  },
}

export const TagsField: IFormField = {
  type: IFieldTypes.SELECT,
  dataKey: FIELD_DATA_KEY.TAGS,
  props: {
    name: FIELD_NAMES.TAGS,
    inputProps: {
      label: 'Tags',
      fullWidth: true,
    },
    selectProps: {
      emptyValueLabel: 'Choose',
      multiple: true,
      showCheckbox: true,
      showSearchfield: true,
    },
    optionsProps: {
      optionArray: [],
    },
  },
}